import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { useTranslation } from '@sunbit-dev/translations';
import { TechnicalErrorContentProp } from './models';
import { ButtonWithImage } from '@sunbit-dev/web-ui-lib';
import disconnectedIcon from '~/assets/disconnected.svg';
import refreshIcon from '~/assets/refresh.svg';
import { useTrack } from '~/hooks/track';
import { EventsNames } from '~/enums/Events';
import { TrackCategory } from '@sunbit-dev/purchase-common/src/services/networkService/models';

export const TechnicalErrorContent = styled(({ className }: TechnicalErrorContentProp) => {
  const { t } = useTranslation('message_page', { keyPrefix: 'technical_error' });
  const { track } = useTrack();

  useEffect(() => {
    track({ eventName: EventsNames.technicalErrorPage, type: TrackCategory.View });
  }, []);

  const onButtonClick = useCallback(() => {
    track({ eventName: EventsNames.tryAgainAfterTechnicalError });
    window.location.reload();
  }, []);

  return (
    <div className={className}>
      <img className="technical-issue-icon" src={disconnectedIcon} alt={t('icon_label')} />
      <div className="text title">{t('title')}</div>
      <div className="text subtitle">{t('subtitle')}</div>
      <div className="text description">{t('description')}</div>
      <ButtonWithImage buttonTheme="blue" className="page-button" onClick={onButtonClick}>
        <img src={refreshIcon} />
        <span className="button-label">{t('button_label')}</span>
      </ButtonWithImage>
    </div>
  );
})`
  ${styles.TechnicalErrorContent}
`;
